module.exports = __webpack_public_path__ + "media/images/sports_icons/paintball-5214b46fa51a8e5b82fe073b0432df91.png";